/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import {Helmet} from 'react-helmet';

import NotificationIcon from '../../../components/layouts/header/notification/NotificationIcon';
import ProfileImage from '../../../components/layouts/header/profile/ProfileImage';
import {useEffect, useState} from 'react';
import {useAdmin} from '../../../app/hooks';
import AdminProductTable from './AdminProductTabel';
import {AdminServices} from '../../../redux/services/admin/admin';
import TableDataSkeleton from '../../../components/ui/skeletonUI/TableDataSkeleton';
import {IProduct} from '../../../components/interfaces/products';
import Pagination from '../../../components/ui/Pagination';
import {BiChevronDown, BiSearch} from 'react-icons/bi';
import {COLORS} from '../../../assets/color';
import Dropdown from '../../../components/forms/Dropdown';
import {toast} from 'react-toastify';
import {Loader} from '../../../assets/svg';
import {useNavigate} from 'react-router-dom';
import {axiosError} from '../../../components/Helpers';
import {addMonths} from 'date-fns';
import DateRangePicker from '../../../components/forms/inputs/selectInput/DateRangePicker';

const Products = ({show}: any) => {
  localStorage.setItem('currentPath', '/admin/products');

  const [products, setProducts] = useState<IProduct[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const token = useAdmin().adminToken;
  const adminEmail = useAdmin().admin.email;

  // Query
  const [query, setQuery] = useState('');
  const keys = ['name', 'vendorMail'];
  const search = (data: any) => {
    return data.filter((item: any) =>
      keys.some((key) =>
        item[key].toLowerCase().includes(query.toLocaleLowerCase())
      )
    );
  };

  // Get Vendors

  // Filter Start and End date
  const [startDate, setStartDate] = useState(new Date('2024-03-01'));
  const [endDate, setEndDate] = useState(addMonths(new Date(), 6));

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
    if (date > endDate) {
      setEndDate(date);
    }
  };

  const handleEndDateChange = (date: any) => {
    setEndDate(date);
  };

  // Get Orders
  useEffect(() => {
    getProducts();
  }, [startDate, endDate]);

  const getProducts = async () => {
    setIsLoading(true);
    try {
      const response = await AdminServices.getProductsWithDateRange(
        token,
        startDate.toISOString().split('T')[0],
        endDate.toISOString().split('T')[0]
      );
      setIsLoading(false);
      // console.log('Reseponse', response);
      if (response.data.status === 'success') {
        const res = response.data?.data.products;
        setProducts(res.rows);
        // console.log(res.rows);
        setIsLoading(false);
        // console.log('profile', profile);
      }
    } catch (error: any) {
      axiosError(error.response);
      setIsLoading(false);
    }
  };
  // console.log(totalPages);
  // Function to handle closing the modal and trigger data reload
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [checkboxEnabled, setCheckboxEnabled] = useState(false);
  const [enabledCheckboxRow, setEnabledCheckboxRow] = useState<
    number | null | string
  >(null);

  const openModal = (rowIndex: any) => {
    setIsModalOpen(true);
    setEnabledCheckboxRow(rowIndex);
  };

  const handleCloseModal = async () => {
    setIsModalOpen(false);
    // setEnabledCheckboxRow(null);
    // Fetch data again after the modal closes
    // await getProducts();
  };

  // Sort --------------------
  const [openSort, setOpenSort] = useState(false);

  const [sortingOption, setSortingOption] =
    useState<keyof IProduct>('createdAt');
  const [isAscending, setIsAscending] = useState(false);

  const handleSortingOptionChange = (newOption: any) => {
    // Toggle sorting order if the same option is selected again
    if (newOption === sortingOption) {
      setIsAscending(!isAscending);
    } else {
      // If a new option is selected, reset sorting order to ascending
      setIsAscending(true);
    }

    // Set the new sorting option
    setSortingOption(newOption);
  };

  const searchData = search(products);

  const sortedData = [...searchData].sort((a, b) => {
    // Use the selected sorting option
    const sortOrder = isAscending ? 1 : -1;
    const aValue = a[sortingOption];
    const bValue = b[sortingOption];

    // Compare values based on the sorting order
    if (aValue < bValue) return -1 * sortOrder;
    if (aValue > bValue) return 1 * sortOrder;
    return 0;
  });

  // Pagination
  const PageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);

  const firstPageIndex = (currentPage - 1) * PageSize;
  const lastPageIndex = firstPageIndex + PageSize;
  const currentTableData = sortedData.slice(firstPageIndex, lastPageIndex);

  // console.log(currentTableData);
  const totalPages = Math.ceil(products.length / PageSize);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle Selected and select Row
  const [selectedRows, setSelectedRows] = useState<{id: any}[]>([]);
  // console.log('Selected Row', selectedRows);

  const handleSelectRows = (selectedRows: {id: any}[]) => {
    setSelectedRows(selectedRows);
  };

  //  Download selected rows to csv
  const downloadSelectedRows = () => {
    // Filter the data based on selectedRows
    const selectedData = products;
    // Create CSV headers
    const csvHeaders = [
      'Product ID',
      'Vendor Email',
      'Name',
      'stock',
      'Price',
      'Status',
      'Approved By',
    ];

    // Convert selectedData to CSV format
    const csvData: string[] = [];
    csvData.push(csvHeaders.join(',')); // Add headers to the CSV data
    selectedData.forEach((row: any) => {
      csvData.push(
        `${row.id},${row.vendorMail},${row.name},${row.quantity},${row.price},${row.status},${row.approvedBy}`
      );
    });

    // Create a CSV string
    const csvString = csvData.join('\n');

    // Create a Blob containing the CSV data
    const blob = new Blob([csvString], {type: 'text/csv'});

    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'products.csv');

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Handle Drop Down
  const options = [
    {value: 'approved', label: 'Approve'},
    {value: 'rejected', label: 'Reject'},
  ];

  const [selectedStatus, setSelectedStatus] = useState('');
  const handleDropdownChange = (selectedValue: string) => {
    // console.log('Selected Value:', selectedValue);
    // Implement your logic here when the dropdown value changes
    setSelectedStatus(selectedValue);
  };

  console.log(selectedRows, 'selected');
  // OnApproval Handler
  const [isApproveLoading, setIsApproveLoading] = useState(false);

  const approveProduct = async () => {
    // Data
    const data = {
      status: selectedStatus,
      approvedBy: adminEmail,
      products: selectedRows,
    };
    setIsApproveLoading(true);
    try {
      const response = await AdminServices.productApproval(token, data);
      // console.log(response);
      if (response.data.status === 'success') {
        toast.success(response.data.data.message);
        setIsApproveLoading(false);

        await getProducts();
        // setTimeout(async () => {
        // }, 2000);
      } else if (
        (response?.data.status === 'failed' &&
          response?.data.message === 'Invalid token or token expired') ||
        response?.data.message === 'Authorization denied! Token expired'
      ) {
        localStorage.clear();
        window.location.reload();
      } else if (
        response?.data.status === 'failed' &&
        response?.data.message === 'ERR no such key'
      ) {
        console.log(response?.data.message);
      } else {
        toast.error(response?.data.message || 'Connection Error');
      }
      setIsApproveLoading(false);
    } catch (error: any) {
      // setIsApproveLoading(false);
      // axiosError(error.response);
      console.log(error);
    }
  };
  const [isFeedback, setIsFeedBack] = useState(false);
  const navigate = useNavigate();
  return (
    <AppContainer>
      <div className='2xl:w-[90%]  md:w-[95%] w-full sm:pt-4 pt-0 h-full'>
        <Helmet>
          <meta charSet='utf-8' />
          <title>Products</title>
        </Helmet>
        <ProductBar>
          <Title>
            <h2>Products</h2>
          </Title>

          <div className='flex flex-row items-center gap-4 justify-end'>
            {/* Search */}
            <div className=' flex flex-row items-center w-full justify-between'>
              {/* Search Input  */}
              <div className='bg-[#F9FBFF] px-4 flex items-center md:w-56 w-full rounded-md shadow-sm lg:shadow-none drop-shadow-sm lg:drop-shadow-none'>
                <div className='input w-full py-[4px] '>
                  <input
                    type='search'
                    placeholder='Search'
                    className='font-circularStdBook p-2 text-[#343A40] w-full border-none focus:border-[#999] focus:shadow-none focus:outline-none bg-transparent placeholder:text-primary'
                    onChange={(e: any) => setQuery(e.target.value)}
                  />
                </div>
                <div className='icon text-gray-200'>
                  <BiSearch size={22} color={COLORS.primary} />
                </div>
              </div>
            </div>
            {/* Notification */}
            <div>
              <NotificationIcon onClick={() => navigate('../admin/messages')} />
            </div>
            {/* Profile Image */}
            <div>
              <ProfileImage onClick={() => ''} />
            </div>
          </div>
        </ProductBar>
        {/* Sort and Date Filter */}
        <div className='flex flex-row items-center justify-end gap-6 pt-4'>
          <button
            onClick={downloadSelectedRows}
            className='bg-primary text-white px-3 py-2 text-center transition-hover rounded-sm'>
            Download CSV
          </button>
          {/* Sort */}
          <div
            onClick={() => setOpenSort(!openSort)}
            className='flex flex-row items-center gap-4 cursor-pointer'>
            <div className='font-poppinsMedium'>Sort by:</div>
            <div className='relative'>
              <div className='flex flex-row items-center gap-10'>
                <p className='text-[#868FE1] text-xs font-poppinsMedium'>
                  {sortingOption === 'createdAt'
                    ? 'Date & Time'
                    : sortingOption === 'name'
                    ? 'Name'
                    : sortingOption === 'quantity'
                    ? 'Stock'
                    : sortingOption === 'price'
                    ? 'Price'
                    : 'Status'}
                </p>
                <BiChevronDown size={20} color='#868FE1' />
              </div>
              {/* Sort DropDown */}
              {openSort && (
                <div
                  onClick={() => setOpenSort(false)}
                  className='bg-white w-full px-2 py-2 flex flex-col items-start absolute rounded-md shadow-md top-8 z-50 text-xs gap-2'>
                  <p
                    className='hover:underline hover:text-[#868FE1]'
                    onClick={() => handleSortingOptionChange('createdAt')}>
                    Date & Time
                  </p>
                  <p
                    className='hover:underline hover:text-[#868FE1]'
                    onClick={() => handleSortingOptionChange('name')}>
                    Name
                  </p>
                  <p
                    className='hover:underline hover:text-[#868FE1]'
                    onClick={() => handleSortingOptionChange('price')}>
                    Price
                  </p>
                  <p
                    className='hover:underline hover:text-[#868FE1]'
                    onClick={() => handleSortingOptionChange('quantity')}>
                    Stock
                  </p>
                  <p
                    className='hover:underline hover:text-[#868FE1]'
                    onClick={() => handleSortingOptionChange('status')}>
                    Status
                  </p>
                </div>
              )}
            </div>
          </div>
          {/* Date Filter */}

          <DateRangePicker
            endDate={endDate}
            onEndDateChange={handleEndDateChange}
            onStartDateChange={handleStartDateChange}
            startDate={startDate}
          />

          {/* Update Category */}
          <button
            onClick={() => navigate('../admin/products/categories')}
            className='bg-primary text-white py-2 px-4 rounded-md'>
            {' '}
            Update Category
          </button>
        </div>
        <div className='inline-flex gap-2 items-center'>
          <p className='text-base font-poppinsMedium'>Note:</p>
          <p className='text-sm text-primary'>
            To enable the checkbox for a product, you must first view it!
          </p>
        </div>

        <div className='sm:p-4  p-2 my-4 rounded-md bg-white'>
          <div className=''>
            {/* New Table */}
            {isLoading ? (
              <TableDataSkeleton />
            ) : (
              <AdminProductTable
                products={search(currentTableData)}
                isModalOpen={isModalOpen}
                handleCloseModal={handleCloseModal}
                setIsModalOpen={setIsModalOpen}
                onSelectRows={handleSelectRows}
                selectedStatus={selectedStatus}
                // checkboxEnabled={checkboxEnabled}
                // setCheckboxEnabled={setCheckboxEnabled}
                openModal={openModal}
                enabledCheckboxRow={enabledCheckboxRow}
                setIsFeedBack={setIsFeedBack}
              />
            )}
          </div>
        </div>
        {/* Button */}
        <div className='flex flex-row justify-center w-full gap-10 py-6'>
          {/* Custom Dropdown */}
          <Dropdown options={options} onChange={handleDropdownChange} />

          {/* Button */}
          <button
            disabled={
              (selectedStatus === 'approved' && enabledCheckboxRow) ||
              (selectedStatus === 'rejected' && isFeedback === true)
                ? false
                : true
            }
            onClick={approveProduct}
            className='bg-primary px-7 py-3 text-white transition-hover rounded-sm font-poppinsMedium disabled:bg-gray-200'>
            {isApproveLoading ? <Loader color={'white'} /> : 'Submit'}
          </button>
        </div>
        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalPages={totalPages}
        />
      </div>
    </AppContainer>
  );
};

const AppContainer = styled.div<any>`
  transition: all 0.25s cubic-bezier(0.3, 0.3, 0.3, 0.3);
`;

const ProductBar = styled.div`
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 4px;
  border-radius: 8px;
`;

const Title = styled.div`
  h2 {
    text-transform: uppercase;
    padding-top: 0.5rem;
    color: ${COLORS.primary};
    font-weight: 600;
    font-size: 1rem;
    padding-left: 0.5rem;
  }
`;

export default Products;
